"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class FieldErrorShelf {
    constructor() {
        this.fieldErrors = [];
        mobx_1.makeAutoObservable(this);
    }
    getFieldError(field) {
        const index = this.fieldErrors.findIndex((error) => error.field === field);
        if (index > -1) {
            return this.fieldErrors[index].message;
        }
        return null;
    }
    hasFieldError(field) {
        return this.fieldErrors.findIndex((error) => error.field === field) > -1;
    }
    addError(error) {
        this.fieldErrors = [...this.fieldErrors, error];
    }
    addErrors(errors) {
        this.fieldErrors = [...this.fieldErrors, ...errors];
    }
    clearErrors() {
        this.fieldErrors = [];
    }
    cleanAndAddErrors(errors) {
        this.clearErrors();
        this.addErrors(errors);
    }
}
exports.default = FieldErrorShelf;
